import { Text, View } from '@react-pdf/renderer';
import { cellPdf, stylesPdf } from '../../../pdfs';
import { columnsReportesEstudiantes } from './ReportesEstudiantes';

const columnWidths = {
  dni: 20,
  fullname: 100,
  actividad1: 12,
  actividad2: 12,
  actividad3: 12,
  actividad4: 12,
  actividad5: 12,
  actividad6: 12,
  actividad7: 12,
  actividad8: 12,
};

const row = (columns, el, i) => {
  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: i,
        width: '10%',
      })}
      {columns.map((column, index) => {
        let data;
        const isUltimo = columns.length - 1 === index;

        if (column.id === 'dni') {
          data = el.usuario.perfil.dni;
        }

        if (column.id === 'fullname') {
          data = `${el.usuario.perfil.pnombre} ${
            el.usuario.perfil.snombre ?? ''
          } ${el.usuario.perfil.papellido} ${
            el.usuario.perfil.sapellido ?? ''
          }`;
        }

        if (column.id === 'actividad1') {
          data = '';
        }
        if (column.id === 'actividad2') {
          data = '';
        }
        if (column.id === 'actividad3') {
          data = '';
        }
        if (column.id === 'actividad4') {
          data = '';
        }
        if (column.id === 'actividad5') {
          data = '';
        }
        if (column.id === 'actividad6') {
          data = '';
        }
        if (column.id === 'actividad7') {
          data = '';
        }
        if (column.id === 'actividad8') {
          data = '';
        }

        return cellPdf({
          value: data,
          width: `${columnWidths[column.id]}%`,
          stylesCell: {
            borderRightWidth: isUltimo ? 1 : 0,
          },
        });
      })}
    </View>
  );
};

function header(columns) {
  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: 'N.',
        width: '10%',
        bold: true,
        color: '#D6D6D6',
        stylesCell: {
          borderTopWidth: 1,
        },
      })}
      {columns.map((column, index) => {
        const isUltimo = columns.length - 1 === index;
        return cellPdf({
          value: column.name,
          width: `${columnWidths[column.id]}%`,
          bold: true,
          color: '#D6D6D6',
          stylesCell: {
            borderTopWidth: 1,
            borderRightWidth: isUltimo ? 1 : 0,
          },
        });
      })}
    </View>
  );
}

const TablaReportesEstudiantes = ({ data, title, columnSelect }) => {
  const columns = [];
  columnSelect.map((el) =>
    columns.push(columnsReportesEstudiantes.find((e) => e.id === el)),
  );

  return (
    <View style={stylesPdf.section}>
      <View style={{ paddingBottom: 10 }}>
        <Text style={stylesPdf.title}>{title}</Text>
      </View>
      {header(columns)}
      {data.map((el, i) => row(columns, el, i + 1))}
    </View>
  );
};

export default TablaReportesEstudiantes;
